// removed by extract-text-webpack-plugin
module.exports = {"White":"#FFFFFF","modalComponent":"Ga23994","modalTitle":"G6c03c3","modalContent":"G0b19f8","modalFooter":"G4d0890"};